// Imports
import React from "react";

import RecSummary from "src/modules/RecSummary/jsx/index.jsx";
import RecTiles from "src/modules/RecTiles/jsx/index.jsx";
import RecNextSteps from "src/modules/RecNextSteps/jsx/index.jsx";
import RecUserActions from "src/modules/RecUserActions/jsx/index.jsx";

const Recommendation = () => {
  return (

      <div className="container container--recommendations" tabIndex={1}>
        <RecSummary
          title="Your recommendations are ready."
          subtitle="Your recommendations below have been selected based on your answers in the quiz."
        />
        <RecTiles />
        <RecNextSteps />
        <RecUserActions />
      </div>
  );
};

export default Recommendation;
